/*eslint react/no-deprecated:0*/
import React from 'react';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { GMapsC } from 'modules/general/component';
import QRCode from 'qrcode.react';

import { ItemListPasajeroC, ItemListPasajeroTemporalC } from './itemListPasajero';
import { PenalizacionesUsuarioC } from 'modules/penalizaciones/component';

import { pickAColor } from 'core/generalFunctions';

import * as viajesActions from 'modules/viajes/action';
import * as generalActions from 'modules/general/action';
import * as reservasActions from 'modules/reservas/action';
import * as penalizacionesActions from 'modules/penalizaciones/action';

moment.locale('es');

@connect((store) => ({
  viaje: store.getIn(['viajes', 'viaje']),
  userRoles: store.getIn(['user', 'roles']),
  reservas: store.getIn(['viajes', 'reservas']),
  cancelarId: store.getIn(['reservas', 'cancelarId']),
}))
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMap: false,
      reservas: this.props.reservas || [],
      filtro: '',
    };
  }
  componentDidMount() {
    this.props.dispatch(generalActions.dashboard_changeTitle('LISTA DE PASAJEROS'));
    if (this.props.params) this.props.dispatch(viajesActions.getById(this.props.params.viajeId));
  }
  componentWillUnmount = () => {
    this.props.dispatch(viajesActions.clear('viaje'));
    this.props.dispatch(viajesActions.clear('reservas'));
  };
  componentWillReceiveProps(newProps) {
    const { viaje } = this.props;
    if (!newProps.viaje) return this.props.dispatch(push('/dashboard/reservas/main/'));
    if (viaje.get('cantReservas') && viaje.get('cantReservas') !== newProps.viaje.get('cantReservas')) this.props.dispatch(viajesActions.getPasajeros(this.props.params.viajeId));
    if (!viaje.getIn(['_trayecto', 'polyline']) && newProps.viaje.getIn(['_trayecto', 'polyline']) && newProps.reservas.size === 0 && this.props.params)
      this.props.dispatch(viajesActions.getPasajeros(this.props.params.viajeId));
    if (!newProps.reservas.equals(this.props.reservas)) this.setState({ reservas: newProps.reservas });
  }
  filtrarReservas = (evento) => {
    const filtro = evento.target.value ? evento.target.value.toLowerCase() : '';

    const reservasFiltradas = this.props.reservas.filter((reserva) => {
      const nombre = reserva.getIn(['_usuario', 'nombre']) || reserva.getIn(['_usuarioCasual', 'nombre']) || '';
      const apellido = reserva.getIn(['_usuario', 'apellido']) || reserva.getIn(['_usuarioCasual', 'apellido']) || '';
      const documento = reserva.getIn(['_usuario', 'documento']) || reserva.getIn(['_usuarioCasual', 'documento']) || '';

      const nombreCompleto = `${nombre} ${apellido}`.toLowerCase();
      return nombreCompleto.includes(filtro) || documento.toLowerCase().includes(filtro);
    });

    this.setState({
      reservas: filtro ? reservasFiltradas : this.props.reservas,
      filtro: evento.target.value, // Agrega esta línea
    });
  };
  newReserva = () => this.props.params && this.props.dispatch(push(`/dashboard/reservas/add/new/${this.props.params.viajeId}`));
  editReserva = (id) => this.props.params && this.props.dispatch(push(`/dashboard/reservas/add/${id}/${this.props.params.viajeId}`));
  goToAbonado = (usuarioId, abonadoId) => this.props.params && this.props.dispatch(push(`/dashboard/abonados/add/${usuarioId || abonadoId}/${Boolean(usuarioId)}`));
  confirmCancelarReserva = (noPenalizar) => {
    if (this.props.cancelarId) this.props.dispatch(reservasActions.cancelarReserva(this.props.cancelarId, true, undefined, undefined, noPenalizar));
    this.props.dispatch(reservasActions.setState({ cancelarId: false }));
  };
  concretarReserva = (reservaId, concretar, viajeId) => this.props.dispatch(reservasActions.concretarReserva(reservaId, concretar, viajeId));
  abonarReserva = (reservaId, abonada, viajeId, cuentaCorriente, penalizacion) => {
    if (!penalizacion || penalizacion.size == 0) this.props.dispatch(reservasActions.abonarReserva(reservaId, abonada, viajeId, cuentaCorriente));
    else this.props.dispatch(penalizacionesActions.setState({ showListaPenalizaciones: true, penalizacionesUsuario: penalizacion }));
  };
  cancelarReserva = (reservaId) => this.props.dispatch(reservasActions.setState({ cancelarId: reservaId ? reservaId : false }));
  verTrayecto = () => this.props.params && this.props.dispatch(push('/dashboard/viajes/trayecto/' + this.props.params.viajeId));
  editarViaje = (viajeId) => this.props.dispatch(push('/dashboard/viajes/add/' + viajeId));
  print = () => window.print();
  render() {
    const { filtro, reservas } = this.state;
    const { viaje, userRoles } = this.props,
      viajeUbicacion = viaje && viaje.getIn(['_localizacion', 0, 'ubicacion']) && viaje.getIn(['_localizacion', 0, 'ubicacion']).toJS(),
      ultimaConexion = viaje && viaje.getIn(['_localizacion', 0, 'fechaEnviado']),
      penalizacionCancelacion = moment(viaje.get('horario')).subtract(viaje.get('penalizacionCancelacionMinutosPrevios'), 'minutes').isBefore(moment());

    if (!viaje) return null;

    return (
      <div>
        <Row className="rowContainer">
          <Col lg={{ size: 10, offset: 1 }} md="12">
            <MaterialUI.Paper zDepth={2} className="container printSmallContainer">
              <Row>
                <Col md="4">
                  <MaterialUI.Table selectable={false}>
                    <MaterialUI.TableBody displayRowCheckbox={false}>
                      {ultimaConexion && (
                        <MaterialUI.TableRow selectable={false} className="no-print littleTableRow">
                          <MaterialUI.TableRowColumn className="littleTableRow">
                            <b>Ultima conexion</b>
                          </MaterialUI.TableRowColumn>
                          <MaterialUI.TableRowColumn className="littleTableRow">{moment(viaje.getIn(['_localizacion', 0, 'fechaEnviado'])).fromNow()}</MaterialUI.TableRowColumn>
                        </MaterialUI.TableRow>
                      )}
                      <MaterialUI.TableRow selectable={false} className="no-print littleTableRow">
                        <MaterialUI.TableRowColumn className="littleTableRow">
                          <b>Salida</b>
                        </MaterialUI.TableRowColumn>
                        <MaterialUI.TableRowColumn className="littleTableRow">{moment(viaje.get('horario')).fromNow()}</MaterialUI.TableRowColumn>
                      </MaterialUI.TableRow>
                      <MaterialUI.TableRow selectable={false} className="no-print littleTableRow">
                        <MaterialUI.TableRowColumn className="littleTableRow">
                          <b>Publico</b>
                        </MaterialUI.TableRowColumn>
                        <MaterialUI.TableRowColumn className="littleTableRow">{viaje.get('publico') ? 'Si' : 'No'}</MaterialUI.TableRowColumn>
                      </MaterialUI.TableRow>
                      <MaterialUI.TableRow selectable={false} className="no-print littleTableRow">
                        <MaterialUI.TableRowColumn className="littleTableRow">
                          <b>Finalizado</b>
                        </MaterialUI.TableRowColumn>
                        <MaterialUI.TableRowColumn className="littleTableRow">{viaje.get('finalizado') ? 'Si' : 'No'}</MaterialUI.TableRowColumn>
                      </MaterialUI.TableRow>
                      <MaterialUI.TableRow selectable={false} className="no-print littleTableRow">
                        <MaterialUI.TableRowColumn className="littleTableRow">
                          <b>Reservas</b>
                        </MaterialUI.TableRowColumn>
                        <MaterialUI.TableRowColumn className="littleTableRow">{viaje.get('reservable') ? 'Admite' : 'No admite'}</MaterialUI.TableRowColumn>
                      </MaterialUI.TableRow>
                      {viaje.getIn(['_chofer', 'nombre']) ? (
                        <MaterialUI.TableRow selectable={false} className="littleTableRow">
                          <MaterialUI.TableRowColumn className="littleTableRow">
                            <b>Chofer</b>
                          </MaterialUI.TableRowColumn>
                          <MaterialUI.TableRowColumn className="littleTableRow">{viaje.getIn(['_chofer', 'nombre'])}</MaterialUI.TableRowColumn>
                        </MaterialUI.TableRow>
                      ) : null}
                      {viaje.getIn(['_vehiculo', 'nombre']) ? (
                        <MaterialUI.TableRow selectable={false} className="littleTableRow">
                          <MaterialUI.TableRowColumn className="littleTableRow">
                            <b>Vehiculo</b>
                          </MaterialUI.TableRowColumn>
                          <MaterialUI.TableRowColumn className="littleTableRow">
                            {viaje.getIn(['_vehiculo', 'nombre'])} - {viaje.getIn(['_vehiculo', 'patente'])}
                          </MaterialUI.TableRowColumn>
                        </MaterialUI.TableRow>
                      ) : null}
                      {viaje.get('velocidad') ? (
                        <MaterialUI.TableRow selectable={false} className="no-print littleTableRow">
                          <MaterialUI.TableRowColumn className="littleTableRow">
                            <b>Velocidad</b>
                          </MaterialUI.TableRowColumn>
                          <MaterialUI.TableRowColumn className="littleTableRow">{viaje.get('velocidad')} km/h</MaterialUI.TableRowColumn>
                        </MaterialUI.TableRow>
                      ) : null}
                      {viaje.hasIn(['_codigo', 'codigo']) ? (
                        <MaterialUI.TableRow selectable={false} className="littleTableRow">
                          <MaterialUI.TableRowColumn className="littleTableRow">
                            <b>Codigo</b>
                          </MaterialUI.TableRowColumn>
                          <MaterialUI.TableRowColumn className="littleTableRow">{viaje.getIn(['_codigo', 'codigo'])}</MaterialUI.TableRowColumn>
                        </MaterialUI.TableRow>
                      ) : null}
                      {viaje.get('precioBoleto') ? (
                        <MaterialUI.TableRow selectable={false} className="littleTableRow">
                          <MaterialUI.TableRowColumn className="littleTableRow">
                            <b>Precio boleto</b>
                          </MaterialUI.TableRowColumn>
                          <MaterialUI.TableRowColumn className="littleTableRow">${viaje.get('precioBoleto')}</MaterialUI.TableRowColumn>
                        </MaterialUI.TableRow>
                      ) : null}
                      {viaje.get('penalizacionCancelacionMinutosPrevios') ? (
                        <MaterialUI.TableRow selectable={false} className="littleTableRow no-print">
                          <MaterialUI.TableRowColumn className="littleTableRow">
                            <b>Pen. cancelacion</b>
                          </MaterialUI.TableRowColumn>
                          <MaterialUI.TableRowColumn className="littleTableRow">
                            {penalizacionCancelacion ? 'Activa' : 'Aún inactiva'} (${viaje.get('penalizacionCancelacionCosto')})
                          </MaterialUI.TableRowColumn>
                        </MaterialUI.TableRow>
                      ) : null}
                    </MaterialUI.TableBody>
                  </MaterialUI.Table>
                </Col>
                <Col md="4" className="pt-10">
                  {viaje && viaje.getIn(['_trayecto', 'nombre']) && (
                    <Row className="rowContainer">
                      <Col lg={{ size: 12 }} md="12">
                        <h2 className="textInside" style={{ color: pickAColor(viaje.get('trayectoId')) }}>
                          {viaje.getIn(['_trayecto', 'nombre'])}
                        </h2>
                        <h1 className="textInside" style={{ color: pickAColor(viaje.get('trayectoId')) }}>
                          {viaje.getIn(['_trayecto', 'subnombre'])}
                        </h1>
                        <h1>
                          {moment(viaje.get('horario')).format('D MMMM')} {moment(viaje.get('horario')).format('HH:mm')}hs
                        </h1>
                      </Col>
                    </Row>
                  )}
                  <div className={viaje.get('cantReservas') >= viaje.get('cantAsientos') ? 'unavailable m-20 no-print' : 'available m-20 no-print'}>
                    <h4>
                      <FontAwesome name={viaje.get('cantReservas') > 10 ? 'users' : 'user'} /> {viaje.get('cantReservas')}/{viaje.get('cantAsientos')}
                    </h4>
                  </div>
                  <div className="container">
                    <MaterialUI.RaisedButton
                      primary={true}
                      label="Editar viaje"
                      buttonStyle={{ backgroundColor: pickAColor(viaje.get('trayectoId')) }}
                      icon={<FontAwesome className="iconBar white" name="edit" />}
                      className="fullWidthComponent noPadding no-print"
                      onTouchTap={() => this.editarViaje(viaje.get('id'))}
                    />
                    <MaterialUI.RaisedButton
                      primary={true}
                      label="Imprimir"
                      buttonStyle={{ backgroundColor: pickAColor(viaje.get('trayectoId')) }}
                      icon={<FontAwesome className="iconBar white" name="print" />}
                      className="fullWidthComponent noPadding no-print"
                      onTouchTap={() => this.print()}
                    />
                    {viajeUbicacion && (
                      <MaterialUI.RaisedButton
                        primary={true}
                        icon={<FontAwesome className="iconBar white" name="map-o" />}
                        label="VER RECORRIDO REALIZADO"
                        onClick={() => this.verTrayecto(viaje.get('id'))}
                        className="fullWidthComponent no-print noPadding m-tb-20"
                      />
                    )}
                  </div>
                </Col>
                <Col md="4" style={{ textAlign: 'center', paddingTop: '10px' }}>
                  {viaje.hasIn(['_codigo', 'codigo']) ? (
                    <QRCode size={250} renderAs={'svg'} className="qrCode no-print" includeMargin={false} value={'https://jaits.app/r?codigo=' + viaje.getIn(['_codigo', 'codigo'])} />
                  ) : (
                    <div className="no-print" style={{ width: '100%', height: '100%' }}>
                      {this.state.showMap ? (
                        <div className="no-print" style={{ width: '100%', height: '100%' }}>
                          <GMapsC marker={viajeUbicacion} mapElement={<div style={{ height: '96%' }} />} containerElement={<div style={{ height: '100%' }} />} />
                        </div>
                      ) : (
                        viajeUbicacion && (
                          <MaterialUI.RaisedButton
                            primary={true}
                            icon={<FontAwesome className="iconBar white" name="map-o" />}
                            label="VER UBICACIÓN DEL VEHICULO"
                            onClick={() => this.setState({ showMap: true })}
                            className="fullWidthComponent noPadding m-tb-20"
                          />
                        )
                      )}
                    </div>
                  )}
                </Col>
                {viajeUbicacion && viaje.hasIn(['_codigo', 'codigo']) && (
                  <Col md="12" className="no-print">
                    <div style={{ width: '100%', height: this.state.showMap ? 200 : 'auto' }} className="no-print">
                      {this.state.showMap ? (
                        <div className="no-print" style={{ width: '100%', height: '100%' }}>
                          <GMapsC marker={viajeUbicacion} mapElement={<div style={{ height: '96%' }} />} containerElement={<div style={{ height: '100%' }} />} />
                        </div>
                      ) : (
                        <MaterialUI.RaisedButton
                          primary={true}
                          icon={<FontAwesome className="iconBar white" name="map-o" />}
                          label="VER UBICACIÓN DEL VEHICULO"
                          onClick={() => this.setState({ showMap: true })}
                          className="fullWidthComponent noPadding m-tb-20"
                        />
                      )}
                    </div>
                  </Col>
                )}
              </Row>
            </MaterialUI.Paper>
            {reservas.size == 0 && (
              <MaterialUI.Paper zDepth={2} className="container m-top-50">
                <h3 className="textCenter p20">No hay pasajeros aún</h3>
              </MaterialUI.Paper>
            )}

            {reservas.size > 0 && (
              <MaterialUI.Paper zDepth={2} className="container m-top-50">
                <Row>
                  <Col md="12">
                    <MaterialUI.TextField
                      hintText="Filtrar por nombre o documento"
                      className="no-print"
                      floatingLabelText="Buscar pasajero"
                      onChange={this.filtrarReservas}
                      value={filtro}
                      fullWidth={true}
                    />
                    <MaterialUI.List className="noPadding">
                      {reservas.map((reservaPasajero) =>
                        !reservaPasajero.get('tmp') ? (
                          <ItemListPasajeroC
                            key={reservaPasajero.get('id')}
                            cancelarReserva={() => this.cancelarReserva(reservaPasajero.get('id'))}
                            editReserva={this.editReserva}
                            goToAbonado={this.goToAbonado}
                            concretarReserva={this.concretarReserva}
                            abonarReserva={this.abonarReserva}
                            reservaPasajero={reservaPasajero}
                          />
                        ) : (
                          <ItemListPasajeroTemporalC key={reservaPasajero.get('id')} reservaPasajero={reservaPasajero} />
                        ),
                      )}
                    </MaterialUI.List>
                  </Col>
                </Row>
              </MaterialUI.Paper>
            )}
          </Col>

          {reservas.size > 0 && (
            <Row className="rowContainer" style={{ width: '100%' }}>
              <Col md="6" className="pt-30 no-print" style={{ alignItem: 'center' }}>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="user-circle" className="iconBar" style={{ fontSize: 22 }} />
                  </Col>
                  <Col md="10">Usuario casual</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="user" className="yellow iconBar" style={{ fontSize: 22 }} />
                  </Col>
                  <Col md="10">Usuario abonado (sin abono activo o creada en oficina)</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="user" className="green iconBar" style={{ fontSize: 22 }} />
                  </Col>
                  <Col md="10">Usuario abonado (con abono activo)</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="mobile" className="green iconBar" style={{ fontSize: 30 }} />
                  </Col>
                  <Col md="10">Usuario app</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="user" className="blue iconBar" style={{ fontSize: 22 }} />
                  </Col>
                  <Col md="10">Ver usuario</Col>
                </Row>
              </Col>
              <Col md="6" className="pt-30 no-print">
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="calendar" className="blue iconBar" style={{ fontSize: 20 }} />
                  </Col>
                  <Col md="10">Reserva programada</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="clock-o" className="red iconBar" style={{ fontSize: 20 }} />
                  </Col>
                  <Col md="10">Reserva programada cancelada por no confirmar</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="bus" className="blue iconBar" style={{ fontSize: 22 }} />
                  </Col>
                  <Col md="10">Reserva creada por chofer</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="ban" className="red iconInfo" />
                  </Col>
                  <Col md="10">Reserva cancelada</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="check" className="blue iconInfo" />
                  </Col>
                  <Col md="10">Reserva concretada</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="check" className="green iconInfo" />
                  </Col>
                  <Col md="10">Reserva confirmada</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="ticket" className="green iconInfo" />
                  </Col>
                  <Col md="10">Creador de la reserva</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="ticket" className="red iconInfo" />
                  </Col>
                  <Col md="10">Responsable de la cancelación de la reserva</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="usd" className="green iconInfo" />
                  </Col>
                  <Col md="10">Indicador de reserva abonada</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="usd" className="red iconInfo" />
                  </Col>
                  <Col md="10">Deuda por penalizaciónes</Col>
                </Row>
                <Row>
                  <Col md="2" className="textCenter">
                    <FontAwesome name="creative-commons" className="blue iconBar" style={{ fontSize: 20 }} />
                  </Col>
                  <Col md="10">Reserva añadida en cuenta corriente</Col>
                </Row>
              </Col>
            </Row>
          )}
        </Row>

        {viaje.get('cantReservas') >= viaje.get('cantAsientos')
          ? null
          : userRoles &&
            userRoles.find((v) => v == 'admin' || v == 'devAdmin' || v == 'administrador_reservas') && (
              <MaterialUI.FloatingActionButton className="bottonFlotanteAdd no-print" onTouchTap={this.newReserva.bind(this)}>
                <FontAwesome name="plus" />
              </MaterialUI.FloatingActionButton>
            )}

        <MaterialUI.Dialog
          title="Confirme para eliminar"
          actions={[
            <MaterialUI.RaisedButton key={1} label="Cancelar" primary={true} onTouchTap={() => this.cancelarReserva()} fullWidth={true} />,
            <MaterialUI.RaisedButton key={2} label="Eliminar" secondary={true} keyboardFocused={true} onTouchTap={() => this.confirmCancelarReserva()} fullWidth={true} className="pt-15" />,
            penalizacionCancelacion && (
              <MaterialUI.RaisedButton key={3} label="Eliminar sin penalizar" secondary={true} onTouchTap={() => this.confirmCancelarReserva(true)} fullWidth={true} className="pt-15" />
            ),
          ]}
          modal={false}
          className="confirmationDialog"
          open={this.props.cancelarId ? true : false}
          onRequestClose={() => this.cancelarReserva()}
        />
        <PenalizacionesUsuarioC />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/viajes/components/pasajeros.js